export const AUDIT_LOG_LICENSE_TITLE = 'Auditlog is disabled';
export const AUDIT_LOG_LICENSE_TEXT =
  'Graylog will not write any new auditlog entries because there is no valid license.';
